import { useAuthentication } from 'core/logic/authentication'
import { SIGN_IN, TO_FIREBASE } from 'core/modules/router'
import BlockLoading from 'components/BlockLoading'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { ReactNode, useEffect, useMemo, useState } from 'react'
import { useUser } from 'context/User'
import {
  useWebviewAuthentication,
  useWebviewIntegration,
} from 'context/WebviewIntegration'
import SectionLoader from 'openspace/components/SectionLoader'

const PrivateRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  const {
    authentication: { authenticated },
  } = useAuthentication()
  const { profile } = useUser()
  const { integrationMode, checkAuthentication } = useWebviewIntegration()
  const [shouldRedirectToSignin, setShouldRedirectToSignin] = useState(false)
  useEffect(() => {
    if (integrationMode && !authenticated)
      checkAuthentication().then((authenticated) => {
        if (!authenticated) setShouldRedirectToSignin(true)
      })
    else setShouldRedirectToSignin(true)
  }, [])

  return (
    <Route
      {...rest}
      render={() => {
        return authenticated && profile?.isLoaded && !profile.isEmpty ? (
          (children as ReactNode)
        ) : authenticated === false && shouldRedirectToSignin ? (
          <Redirect to={TO_FIREBASE[SIGN_IN]} />
        ) : (
          <SectionLoader />
        )
      }}
    />
  )
}
export default PrivateRoute
